import angular from 'angular';

import CreateTeacherAccountController from './create-teacher-account-controller';

const createTeacherAccount = angular.module('createTeacherAccount', []);
createTeacherAccount.controller('CreateTeacherAccountController', CreateTeacherAccountController);

export default createTeacherAccount.name;
